<template>
  <div class="container">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/cleanex-step1')"></span>
    </div>
    <div class="title">请选择您的户型</div>
		<div class="main clearfix">
			<div class="cell" @click="orderUpdate('house_layout','1');showModal = true">
				<div class="type">Master Room</div>
				<div class="description">1房间 1卫生间</div>
			</div>

			<div class="cell" @click="orderUpdate('house_layout','2');showModal = true">
				<div class="type">一室一卫</div>
				<div class="description"> 1客厅 1房间 1卫生间</div>
			</div>
			<div class="cell" @click="orderUpdate('house_layout','3');showModal = true">
				<div class="type">两室一卫</div>
				<div class="description"> 1客厅 2房间 1卫生间</div>
			</div>
			<div class="cell" @click="orderUpdate('house_layout','4');showModal = true">
				<div class="type">两室两卫</div>
				<div class="description"> 1客厅 2房间 2卫生间</div>
			</div>
			<div class="cell" @click="orderUpdate('house_layout','5');showModal = true">
				<div class="type">三室一卫</div>
				<div class="description"> 1客厅 3房间 1卫生间</div>
			</div>
			<div class="cell" @click="orderUpdate('house_layout','6');showModal = true">
				<div class="type">三室两卫</div>
				<div class="description"> 1客厅 3房间 2卫生间</div>
			</div>
		</div>
		<div class="dual-cell" @click="orderUpdate('house_layout','7');showModal = true">
			<div class="type">其他户型 <span style="color:#888">/</span> 别墅户型</div>
			<div class="description"> 如果你的户型不在上列选项，请点击此项</div>
		</div>
		<transition name="fade">
			<v-modal  v-if="showModal" @close="showModal = false">
				<div slot="body">
					<div class="modal-title">地毯是否需要清洁</div>
					<div class="multilayer">
						<div class="option-btn" @click="needCarpet()" v-bind:class="{ active: order.data.is_carpet == 1 }">需要</div>
						<div class="option-btn" @click="orderUpdate('is_carpet',0)" v-bind:class="{ active: order.data.is_carpet == 0 }">不需要</div>
					</div>

					<div class="info-box">
						<div>
							<div v-show="order.data.is_carpet==0||order.data.is_carpet==3">
								<div class="info">到家提供专业地毯清洁服务</div>
							</div>
							<div v-show="order.data.is_carpet == 1">
								<div class="info">地毯清洁服务 $70 起</div>
							</div>
							<!-- <div v-show="order.data.is_carpet == 1">
								<v-counter @plus="plus" @minus="minus" :num='order.data.carpet' type='carpet'>
								<span slot="label">清洁房间数</span>
								</v-counter>
								<div class="carpetInfo"> （ 卧室、客厅及其他含地毯的房间都算在内 ）</div>
							</div> -->
						</div>
					</div>

					<div class="btn-box">
						<div class="btn mgt10" :class="{ active: order.data.is_carpet!='3'}" @click="submitNext()">下一步</div>
					</div>
				</div>
			</v-modal>
		</transition>

  </div>
</template>

<script>
export default {
  name: 'cleanEx-step1',
  data () {
    return {
		showModal: false,
      	order:{
			service:'cleanEx',
			data:{
			},
			temp:{
				isAM:'',
				isPM:'',
				isDate:''
			}
      	}
    }
  },
  methods: {
    plus: function (type) {
      	eval('this.order.data.'+type+'=this.order.data.'+type+'+1');
		if(this.order.data[type]>5){
			this.order.data[type]=5;
		}
	},
    minus: function (type) {
		eval('this.order.data.'+type+'=this.order.data.'+type+'-1');
		if(this.order.data[type]<1){
			this.order.data[type]=1;
		}
    },
    allFilled(){
      if(this.order.data.is_duplex !== '3'){
        return true;
      }
    },
    needCarpet(){
      this.orderUpdate('is_carpet',1);
      if(this.order.data.is_carpet==1 && this.order.data.carpet==0){
        this.order.data.carpet=1;
      }
	},
    submitNext(){
      if(this.allFilled()){
          if(this.order.data.is_carpet==3){
            alert('请选择是否需要清洁地毯')
          }
          else if(this.order.data.is_carpet==0){
            this.order.data.carpet = 0;
            this.orderUpdateAll('/cleanex-step3');
          }
          else{
            this.orderUpdateAll('/cleanex-step3');
          }
      }
      else{
          alert('请填写完所有房间数目')
      }
    },
  },
  components: {
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "cleanEx"){
		this.order = localParsed;
        if(this.order.data.type_id=="1550735962"){
			this.order.data.house_layout = "1562662349";
			this.order.data.is_carpet=0;
			this.order.data.carpet=0;
			this.orderUpdateAll('');
			this.$router.replace('/cleanex-step3');
        }
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.multilayer{
	text-align:center;
	margin:20px 0;
}

.info-box{
	min-height:60px;
	padding-top:13px;
}

.info{
	font-weight:100;
	text-align:center;
	padding-top:4px;
}

.btn{
  width: 250px;
  height: 50px;
	margin-top:10px;
	background: #ddd;
	color:#666;
}
.btn.active{
  color:#fff;
	background: rgb(237,121,75);
	background: linear-gradient(90deg, #ff7444 0%,#fe9567 100%);
	-webkit-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
	-moz-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
  box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
}
.modal-title{
	font-size:1.8em;
	font-weight:bold;
	text-align:center;
	color:#555;
}
.main{
  padding:30px 30px 0 30px;
}
.cell{
	float:left;
	width:50%;
	border-bottom:1px solid #DDD;
	box-sizing: border-box;
	height: 100px;
	text-align: center;
	cursor: pointer;
}
.cell:active{
	background: #eee;
}
.cell:nth-child(odd) {
	border-right:1px solid #DDD;
}
.cell.last{
	border-bottom:0;
}
.cell img{
	width:60px;
}

.type{
	font-size:1.1em;
	font-weight:bold;
	color:#fe9567;
	margin-top:25px;
}
.description{
	color:#666;
	font-size:0.7em;
}

.dual-cell{
	text-align:center;
}

.fade-enter {
  opacity: 0;
}

.fade-leave-active {
  opacity: 0;
}

.fade-enter .modal-container,
.fade-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.option-btn{
  border:2px solid #fe9567;
  border-radius:4px;
  min-width:68px;
	padding:0 8px;
  height:34px;
  line-height:34px;
  color:#ff7444;
  display:inline-block;
  margin:0 4px;
	text-align:center;
}

.option-btn.active{
  border:2px solid #fe9567;
  border-radius:4px;
  width:68px;
  height:34px;
  line-height:34px;
  background-color:#fe9567;
  color:#fff;
  display:inline-block;
  margin:0 4px;
	-webkit-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
	-moz-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
  box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
}

.carpetInfo{
	font-weight:100;
	text-align:center;
	padding-top:4px;
  font-size:0.8em;
  margin-bottom:20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/cleanEx/step2.vue